import React, { createContext, useEffect, useState } from "react";
import {
  getAllNews,
  getAllProducts,
  getAllReciepe,
  getAwards,
  getHomeNews,
  getWebParts,
  getProducts,
  getHomeProducts,
} from "../services/api";
import { useLocation } from "react-router-dom";

//context
export const dataContext = createContext();

const DataContextProviderr = (props) => {
  const location = useLocation();
  const [allWebParts, setAllWebParts] = useState();
  //loading
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      location.pathname === "/products" ||
      location.pathname === "/" ||
      location.pathname === "/certificates" ||
      location.pathname === "/news" ||
      location.pathname === "/aboutUs" ||
      location.pathname === "/contactUs"
    ) {
      setIsLoading(true);
      const fetchApiWebParts = async () => {
        const data = await getWebParts();
        setAllWebParts(data);
        // if (location.pathname === "/aboutUs") {
        //   setTimeout(() => {
        //     setIsLoading(false);
        //   }, 2000);
        // }
        // if (location.pathname !== "/aboutUs") {
        //   setIsLoading(false);
        // }

        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      };
      fetchApiWebParts();
    }
  }, [location]);

  //products
  const [allProducts, setAllProducts] = useState();
  const [isLoadingProduct, setIsLoadingProduct] = useState(false);

  useEffect(() => {
    if (location.pathname === "/products" || location.pathname === "/") {
      setIsLoadingProduct(true);
      const fetchApiAllProducts = async () => {
        setAllProducts(await getAllProducts());
        setTimeout(() => {
          setIsLoadingProduct(false);
        }, 1000);
      };
      fetchApiAllProducts();
    }
  }, [location]);

  const [homeProduct, setHomeProduct] = useState();
  useEffect(() => {
    if (location.pathname === "/") {
      const fetchApiOilProducts = async () => {
        setHomeProduct(await getHomeProducts());
      };
      fetchApiOilProducts();
    }
  }, [location]);

  const [allReciepe, setAllReciepe] = useState([]);
  useEffect(() => {
    if (location.pathname === "/products") {
      const fetchApiAllReciepe = async () => {
        setAllReciepe(await getAllReciepe());
      };
      fetchApiAllReciepe();
    }
  }, [location]);

  //news
  const [allNews, setAllNews] = useState([]);
  const [homeNews, setHomeNews] = useState([]);
  const [isLoadingNews, setIsLoadingNews] = useState(false);

  useEffect(() => {
    if (
      location.pathname.toLocaleLowerCase().startsWith("/news") ||
      location.pathname === "/" ||
      location.pathname === "/news"
    ) {
      const fetchApiHomeNews = async () => {
        setHomeNews(await getHomeNews());
      };
      fetchApiHomeNews();
    }
  }, [location]);

  useEffect(() => {
    if (
      location.pathname.toLocaleLowerCase().startsWith("/news") ||
      location.pathname === "/news"
    ) {
      setIsLoadingNews(true);
      const fetchApiAllNews = async () => {
        setAllNews(await getAllNews());
        setTimeout(() => {
          setIsLoadingNews(false);
        }, 1000);
      };
      fetchApiAllNews();
    }
  }, [location]);

  //awards
  const [awards, setAwards] = useState([]);
  const [isLoadingAwards, setIsLoadingAwards] = useState(false);

  useEffect(() => {
    if (location.pathname === "/certificates") {
      setIsLoadingAwards(true);
      const fetchApiSlides = async () => {
        const data = await getAwards();
        setAwards(data);
        setTimeout(() => {
          setIsLoadingAwards(false)
        }, 1000);
      };
      fetchApiSlides();
    }
  }, [location]);

  return (
    <dataContext.Provider
      value={{
        allWebParts,
        allProducts,
        allReciepe,
        isLoading,
        isLoadingProduct,
        homeProduct,

        allNews,
        isLoadingNews,
        homeNews,

        isLoadingAwards,
        awards,
      }}
    >
      {props.children}
    </dataContext.Provider>
  );
};

export default DataContextProviderr;
